export function download(response) {
  const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
  const headerval = response.headers['content-disposition'];
  const fileName = headerval.split(';')[1].split('=')[1].replace('"', '').replace('"', '');

  const link = document.createElement('a');

  link.href = downloadUrl;

  link.setAttribute('download', fileName);

  document.body.appendChild(link);

  link.click();

  link.remove();
}